import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericModalTypes, GenericModalWithIconContent } from '../../shared';
import { DropShiftModalSuccessButton } from './DropShiftModalSuccessButton/DropShiftModalSuccessButton.web';
export var DropShiftModalSuccess = function (_a) {
    var close = _a.close;
    var t = useTranslation().t;
    return (React.createElement(GenericModalWithIconContent, { dataTestId: "DropShiftModalSuccess", mainText: t('shift_management_features_DropShiftModal_shiftDropped'), onClose: close, buttons: [React.createElement(DropShiftModalSuccessButton, { onClick: close, key: "OK" })], type: GenericModalTypes.success }));
};
